import { useCallback, useState } from "react";
import {
  LocationInstrumentsWithFiltersRequest,
  LocationWithName,
} from "../../api/locationApi.ts";
import { LocationFormData } from "./LocationForm.tsx";

export function useLocationFormState() {
  const [formState, setFormState] = useState<LocationFormData>();

  const updateFormState = useCallback((updates: Partial<LocationFormData>) => {
    setFormState((prev) => {
      if (!prev) {
        // If prev is undefined, create a new state with the updates
        return updates as LocationFormData;
      }
      return { ...prev, ...updates };
    });
  }, []);

  const initializeFromLocation = useCallback((location: LocationWithName) => {
    const addressData = location.countryCode
      ? {
          id: location.id,
          longitude: location.longitude,
          latitude: location.latitude,
          streetName: location.streetName,
          houseNumber: location.houseNumber || "",
          city: location.city || "",
          postalCode: location.postalCode || "",
          countryCode: location.countryCode || "",
          timeZone: location.timeZone || "",
          region: location.region || "",
          buildingName: location.buildingName,
          subBuildingName: location.subBuildingName,
          locationType: location.locationType,
        }
      : null;

    const instruments: LocationInstrumentsWithFiltersRequest[] =
      location.instruments.map((value) => ({
        name: value.name,
        filters: value.filters.map((filter) => filter.name),
      }));

    setFormState({
      name: location.name || "",
      instruments: instruments || [],
      locationType: location.locationType || "IN_PERSON",
      selectedAddress: addressData,
    });
  }, []);

  return {
    formState,
    updateFormState,
    initializeFromLocation,
  };
}
